import createReactComponent from '../createReactComponent';
export default createReactComponent('check', 'IconCheck', [
  ['path', { d: 'M5 12l5 5l10 -10', key: 'svg-0' }],
]);
